document.addEventListener("DOMContentLoaded", (event) => {

    const isFG = document.getElementById('fachgebiet-select');

    function removeActive( EleList ){
        EleList.forEach(ele =>{
            ele.classList.remove('active');
        })
    }

    function setajaxFG( id ){
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
              cat: id,
              action: 'filter_pills_fg',
            },
            success: function(res) {
                $('#fg-content').html(res);
            }
          })
    }

    if(isFG){

        var $ = require( "jquery" );

        //let pillButtons = Array.from(document.querySelectorAll('[data-secindex]'));
        let allButtons = Array.from(document.querySelectorAll('[data-primaryindex]'));
        let pillButtons = Array.from(document.querySelectorAll('[data-secindex]'));

        pillButtons.forEach(pill => {
            pill.addEventListener('click', ()=>{

                removeActive(pillButtons);
                removeActive(allButtons);
                pill.classList.add('active');

                let indexId = pill.dataset.secindex;
                setajaxFG(indexId);
            });
        });

        allButtons.forEach(button => {
            button.addEventListener('click', ()=>{

                removeActive(allButtons);
                removeActive(pillButtons);
                button.classList.add('active');

                let indexId = button.dataset.primaryindex;
                setajaxFG(indexId);
            });
        });

        
    }

});